<template>
	<div class="control-wrap">
		<el-dialog class="dialog-wrap" width="650px" :visible="true" :append-to-body='true' :show-close="false" v-if="kind == 10">
			<h1 slot="title" style="font-size: 0.25rem">控制参数设定</h1>
			<div class="d-flex mb-2" v-if="!hidden">
				<img width="200px" src="~@/assets/device.png" />
				<div class="ml-3 d-flex jc-around flex-column">
					<p>安装位置：{{ surveyData.location }}</p>
					<p>当前温度：{{ surveyData.snwd }}℃</p>
					<p>当前湿度：{{ surveyData.snsd }}%</p>
					<p>数据时间：{{ surveyData.sjsj }}</p>
				</div>
			</div>
			<el-form ref="form" :model="form" label-width="120px" size="small">
				<el-form-item label="开关机" class="switch">
					<el-radio-group v-model="form.switch">
						<el-radio :label="1">开机</el-radio>
						<el-radio :label="0">关机</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="球阀开度" v-if="surveyData.control_panel_type == 40">
					<div class="valveOpening">
						<el-slider v-model="valveOpening" show-input></el-slider>
					</div>
				</el-form-item>
				<el-form-item label="运行模式">
					<el-select v-model="form.running_mode">
						<el-option v-for="item in modelData" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="温度阈值">
					<el-input v-model="form.temp_limit" style="width: 3.125rem;"></el-input>℃
				</el-form-item>
				<el-form-item label="湿度范围">
					<el-input v-model="form.humidity_down_limit" style="width: 1.875rem;"></el-input>
					<span style="display:inline-block;width:10%;color:#bbb;text-align: center;">—</span>
					<el-input v-model="form.humidity_up_limit" style="width: 1.875rem;"></el-input>
					<span class="unit">%</span>
				</el-form-item>
				<el-form-item label="风速设定">
					<el-select v-model="form.wind_set">
						<el-option v-for="item in windData" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template slot="footer">
				<el-button @click="cancel()">取消</el-button>
				<el-button type="primary" @click="sure()">
					确 定
				</el-button>
			</template>
		</el-dialog>

		<el-dialog width="650px" :visible="true" :show-close="false" v-if="kind == 30">
			<h1 slot="title">水泵控制参数</h1>
			<div class="d-flex mb-2 ml-3" style="width: 500px;height: 164px;">
				<img src="~@/assets/sb.png" style="float: left;width: 250px;height: 164px;" />
				<div class="ml-2 d-flex jc-around flex-column pt30">
					<p>安装位置：{{ surveyData.location }}</p>
					<p>设备型号：{{ surveyData.pump_mode }}</p>
					<p>数据时间：{{ surveyData.SJSJ }}</p>
				</div>
			</div>
			<el-form ref="form" :model="form" label-width="120px" size="small">
				<el-form-item label="开关">
					<el-radio-group v-model="form.switch" disabled>
						<el-radio :label="1">开机</el-radio>
						<el-radio :label="0">关机</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="运行模式">
					<el-select v-model="form.running_mode" disabled>
						<el-option label="正转" value="10"></el-option>
						<el-option label="反转" value="20"></el-option>
						<el-option label="停止" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运行频率">
					<el-input v-model="form.yxpl" disabled></el-input>
				</el-form-item>
			</el-form>
			<template slot="footer">
				<el-button type="primary" @click="cancel()">取 消</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				code: '',
				surveyData: {},
				modelData: [],
				windData: [{
						label: '自动风',
						value: 0
					},
					{
						label: '高风',
						value: 1
					},
					{
						label: '中风',
						value: 10
					},
					{
						label: '低风',
						value: 11
					}
				],
				form: {
					switch: 1,
					running_mode: 0,
					temp_limit: '20',
					high_temp_down_limit: '',
					high_temp_up_limit: '',
					low_temp_down_limit: '',
					low_temp_up_limit: '',
					humidity_down_limit: '35',
					humidity_up_limit: '75',
					wind_set: 0,
					code: ''
				},
				valveOpening: 10,
				hidden: false,
			};
		},
		
		props: ['deviceCode', 'kind'],

		// 全局vue.js不强制刷新或者重启时只创建一次,也就是说,created()只会触发一次
		created() {
			this.init()
		},

		// 进入当前存在activated()函数的页面时,一进入页面就触发,可以用于列表数据等的刷新
		activated() {
			//
		},

		// 通常是初始化页面完成后，再对html的dom节点进行一些需要的操作
		mounted() {
			
		},
		methods: {
			init() {
				if (this.kind == 10) {
					let codes = this.deviceCode.split(',');
					if (codes.length === 1) {
						this.code = String(this.deviceCode);
						this.getDeviceSurvey();
						this.getKtDqCs();
					} else {
						this.code = this.deviceCode;
						this.hidden = true;
					}
					this.getRunModels();
				} else if (this.kind == 20) {
					// this.getPumpSurvey();
				}
			},
			
			async getDeviceSurvey() {
				let dataObj = {
					deviceCode: this.deviceCode
				}
				await this.$axios.get("/api/airConditions/survey", {
					params: dataObj
				}).then(res => {
					this.surveyData = res.data.data
				})
			},
			
			async getPumpSurvey() {
				let dataObj = {
					deviceCode: this.deviceCode
				}
				await this.$axios.get("/api/pumps/currentRunning", {
					params: dataObj
				}).then(res => {
					this.surveyData = res.data.data;
					this.form.switch = res.data.data.KGJ;
					this.form.yxpl = res.data.data.YXPL;
				})
			},
			
			async getKtDqCs() {
				let dataObj = {
					deviceCode: this.deviceCode
				}
				await this.$axios.get("/api/gatherSystems/getKtDqCs", {
					params: dataObj
				}).then(res => {
					if ((this.surveyData).control_panel_type == 40) {
						this.valveOpening = res.data.data.valve_opening;
					}
					if (JSON.stringify(res.data.data) != null) {
						this.form.switch = res.data.data.switch;
						this.form.running_mode = res.data.data.running_mode;
						this.form.temp_limit = res.data.data.temp_limit;
						this.form.high_temp_down_limit = res.data.data.high_temp_down_limit;
						this.form.high_temp_up_limit = res.data.data.high_temp_up_limit;
						this.form.low_temp_down_limit = res.data.data.low_temp_down_limit;
						this.form.low_temp_up_limit = res.data.data.low_temp_up_limit;
						this.form.humidity_down_limit = res.data.data.humidity_down_limit;
						this.form.humidity_up_limit = res.data.data.humidity_up_limit;
						this.form.wind_set = res.data.data.wind_set;
					} else {
						// this.$tip('上次配置获取失败！', 'warning');
					}
				})
			},
			
			async getRunModels() {
				let dataObj = {
					deviceCodes: this.deviceCode
				}
				await this.$axios.get("/api/airConditions/controlDeviceModel", {
					params: dataObj
				}).then(res => {
					this.modelData = res.data.data;
				})
			},
			
			changeDialogVisible(b) {
				// console.log(b);
			},
			
			cancel() {
				this.$emit('changeDialogVisible', false);
			},
			
			sure() {
				this.form.code = this.code;
				if ((this.surveyData).control_panel_type == 40) {
					this.form.valve_opening = this.valveOpening;
				}
				
				let dataObj = {
					commonSet: {
						switch: Number(this.form.switch),
						running_mode: Number(this.form.running_mode),
						temp_limit: Number(this.form.temp_limit),
						high_temp_down_limit: Number(this.form.high_temp_down_limit),
						high_temp_up_limit: Number(this.form.high_temp_up_limit),
						low_temp_down_limit: Number(this.form.low_temp_down_limit),
						low_temp_up_limit: Number(this.form.low_temp_up_limit),
						humidity_down_limit: Number(this.form.humidity_down_limit),
						humidity_up_limit: Number(this.form.humidity_up_limit),
						wind_set: this.form.wind_set,
						code: this.form.code
					}
				}
				this.$axios.put("/api/gatherSystems/deviceControl", dataObj).then(res => {
					this.cancel();
				})
			},
		}
	}
</script>

<style lang="scss">
	.control-wrap {
		width: 100%;

		.el-select {
			width: 100%;
		}

		.el-dialog__body {
			padding: 30px 140px 0 30px;

			.unit {
				top: 0;
				right: -30px;
				position: absolute;
			}
		}

		.switch {
			display: flex;
			justify-content: flex-start;

			.el-form-item__content {
				margin-left: 0 !important;
				display: flex;
				align-items: center;
				flex-wrap: nowrap;
			}

			.valveOpening {
				margin-left: 20px;
				width: 206px;
				display: flex;
				flex-wrap: nowrap;
				justify-content: space-between;
				align-items: center;

				.el-slider__runway {
					width: 140px;
				}
			}
		}
	}
</style>
